import script from "./grid-statistics.vue?vue&type=script&setup=true&lang=js"
export * from "./grid-statistics.vue?vue&type=script&setup=true&lang=js"

import "./grid-statistics.vue?vue&type=style&index=0&id=20ab61a6&lang=scss"

const __exports__ = script;

export default __exports__